// @core/api/endpoints/tag/batch_get_entity_tags.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BatchGetEntityTagsRequest,
  BatchGetEntityTagsResponse,
} from '../../../types/tag';

const BASE_PATH = '/tag';

/**
 * Batch get entity tags
 * Returns tags for multiple entities in a single request. Designed for list views where you need to show tags for many entities at once. Max 100 entities per request.
 */
export async function BatchGetEntityTags(
  data: BatchGetEntityTagsRequest,
  options?: RequestOptions
): Promise<BatchGetEntityTagsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tags/batch`;
  const requestOptions = options;
  return client.post<BatchGetEntityTagsResponse>(requestPath, data, requestOptions);
}
